<div class="card-labels-container">
  <div class="labels left">
    <ng-content select="[slot=left]"></ng-content>
  </div>
  <div class="labels right">
    <ng-content select="[slot=right]"></ng-content>
  </div>
</div>
